<div class="page-header">
    <div class="page-header-info">{{userInfo?.productType}} {{userInfo?.policyNumber}}</div>
    <bolt-notification style="padding-bottom: 20px;" *ngIf="userInfo?.balance > cardPaymentAmountLimit" type="info">Please note that card payments are limited to {{cardPaymentAmountLimit | currency:'USD'}}, however payments via bank account (ACH) are available for payments greater than this amount.</bolt-notification>
    <div class="page-header-text">Payment amount</div>
</div>

<div class="page-body" *ngIf="isGracePayment">
    <div class="body-text" data-testid="paymentLapseDateText">
        This is the full amount needed by {{userInfo?.lapseDate | date:'MM/dd/yyyy'}} to maintain your life insurance coverage.
    </div>
    <div class="body-text body-middle-text">This payment will reflect today’s date.</div>

    <div class="current-due" data-testid="paymentCurrentAmountDue">Current amount due: {{userInfo?.balance | currency:'USD'}}</div>
</div>

<div class="page-body" *ngIf="!isGracePayment">

    <div class="body-text" *ngIf="isPendingPolicy">The payment amount displayed below includes your first premium
        payment plus <br />
        any other lump sum or deposit amount needed<span *ngIf="!isPartialAllowed">&nbsp;at this time</span>.
    </div>
    <div class="body-text" *ngIf="isPendingPolicy&&!isPartialAllowed"> <span class="body-bold">Note:</span>&nbsp;
        The actual amount of your regular premium payments could change. If <br>that’s the case, your financial
        professional will discuss your options with you.
    </div>
    <div class="body-text body-middle-text">This payment will reflect today’s date.</div>
    <div class="body-bold tM-10px bM-20px body-text" *ngIf="isPendingPolicy && isPartialAllowed">
        <div>You currently owe:</div>
        <div>{{userInfo?.balance | currency:'USD'}}</div>
    </div>
    <form [formGroup]="myform" id="myform" novalidate>
        <fieldset class="bolt-fieldset bolt--radios"
            [ngClass]="{'bolt-invalid':myform.get('paymentOption')?.touched && myform.get('paymentOption')?.errors?.['required']}"
            *ngIf="isPartialAllowed">
            <legend>
                <span class="bolt-fieldset__name">
                    Select the amount you would like to pay:
                </span>
                <div class="bolt-fieldset__errors"
                    *ngIf="myform.get('paymentOption')?.touched && myform.get('paymentOption')?.errors?.['required']">
                    <bolt-field-error>
                        Please select one of the payment options.
                    </bolt-field-error>
                </div>
            </legend>
            <div class="bolt-fieldset__body">
                <bolt-radio-control>
                    <input id="option_1" name="paymentOption" type="radio" value="1" formControlName="paymentOption"
                        ngDefaultControl />
                    <label for="option_1">
                        <bolt-radio-facade></bolt-radio-facade>
                        <div class="bolt-field__label" *ngIf="userInfo?.balance<paymentAmountLimit">
                            <span>{{userInfo?.balance | currency:'USD'}}&nbsp;(I want to pay the&nbsp;<span
                                    class="body-bold">full</span>&nbsp;amount currently
                                due.)</span>
                        </div>
                        <div class="bolt-field__label" *ngIf="userInfo?.balance>=paymentAmountLimit">
                            <span>{{paymentAmountLimit | currency:'USD'}} (I want to pay the&nbsp;<span class="body-bold">maximum I can transfer
                                    over ACH</span>.)</span>
                        </div>

                    </label>
                </bolt-radio-control>
                <bolt-radio-control>
                    <input id="option_2" name="paymentOption" type="radio" value="2" formControlName="paymentOption"
                        ngDefaultControl />
                    <label for="option_2">
                        <bolt-radio-facade></bolt-radio-facade>
                        <div class="bolt-field__label" *ngIf="userInfo?.balance<paymentAmountLimit">
                            <span>I want to pay&nbsp;<span class="body-bold">less than</span>&nbsp;the full amount
                                currently due.</span>
                        </div>
                        <div class="bolt-field__label" *ngIf="userInfo?.balance>=paymentAmountLimit">
                            <span>I want to pay an amount&nbsp;<span class="body-bold">less
                                    than</span>&nbsp;{{paymentAmountLimit | currency:'USD'}}.</span>
                        </div>
                    </label>
                </bolt-radio-control>
            </div>
        </fieldset>
        <div class="current-due" *ngIf="!isPartialAllowed">Current amount due: {{userInfo?.balance | currency:'USD'}}</div>
        <div class="amount-field-container" *ngIf="myform.get('paymentOption')?.value == 2">
            <bolt-input-control class="amount-field">
                <label for="paymentAmount">
                    <span>Enter the amount you would like to pay today:</span>
                    <bolt-contextual-help type="push">
                        <p><b>Your Payment amount must be greater than $1 and no more than the full amount currently due.</b></p>
                    </bolt-contextual-help>
                </label>
                <bolt-input-facade>
                    <span class="bolt-prefix bolt-symbol">$</span>
                    <input id="paymentAmount" type="text" formControlName="paymentAmount" required 
                    mask="separator.2" thousandSeparator="," decimalMarker="." />
                </bolt-input-facade>
                <footer>
                    <div class="bolt-error" id="ERROR_ID"
                        *ngIf="myform.get('paymentAmount')?.touched && !myform.get('paymentAmount')?.valid && 
                        myform.get('paymentAmount')?.hasError('min')">
                        <bolt-field-error>Please enter a dollar amount. You must enter an amount of at least
                            $1.00.</bolt-field-error>
                    </div>
                    <div class="bolt-error" id="ERROR_ID"
                        *ngIf="myform.get('paymentAmount')?.touched && !myform.get('paymentAmount')?.valid && 
                        myform.get('paymentAmount')?.hasError('max')">
                        <bolt-field-error>You have entered an amount greater than the balance due. Please select to pay the full amount currently due or enter a number less than the amount due.</bolt-field-error>
                    </div>
                </footer>
            </bolt-input-control>

            <div class="body-text" *ngIf="isPendingPolicy">
                <span class="body-bold">Note:</span>&nbsp;
                If you do not pay the full amount due, you may not be covered <br />
                by a temporary insurance agreement (TIA). Ask your financial professional <br />
                for details.
            </div>
        </div>
    </form>
</div>
<div class="page-footer">
    <bolt-button-bar class="footer-button-bar">
        <bolt-button slot="cancel" data-testid="paymentCancelButton" (click)="onCancel()">Cancel</bolt-button>
        <bolt-button slot="back" data-testid="paymentBackButton" (click)="onBack()">Back</bolt-button>
        <bolt-button slot="forward" type="primary" [disabled]="!isGracePayment && !this.myform.valid && this.isPartialAllowed" (click)="onSubmit()">Continue to payment method</bolt-button>
    </bolt-button-bar>
</div>